export default {
  account: {
    attributes: {
      name: 'Nome',
      type: 'Tipo',
    },
    header: {
      title: 'Serviço de Email',
      subtitle: 'Configure um Serviço de E-mail que você usa ou todos eles !',
      searchAccount: 'Procurar uma Conta',
    },
    list: {
      insert_date: 'Adicionado em',
      actions: 'Ações',
      deprecated: 'Descontinuado',
    },
    editModal: {
      header: 'Adiciona conta de serviço de e-mail',
      helpBlock: 'Preencha o formulário abaixo por favor.',
      select: 'Selecione',
      save: 'Salvar',
      activeCampaign: {
        apiKey: 'Key',
        apiKeyPlaceholder: 'API Key',
        apiUrl: 'URL',
        apiUrlPlaceholder: 'API URL',
      },
      aweber: {
        help: 'Para finalizar a integração com o Aweber, clique no botão Salvar abaixo.',
      },
      convertKit: {
        apiKey: 'Key',
        apiKeyPlaceholder: 'API Key',
        apiSecret: 'Secret',
        apiSecretPlaceholder: 'API Secret',
      },
      eGoi: {
        apiKey: 'Sua API Key',
      },
      getResponse: {
        apiKey: 'GetResponse API Key',
        apiKeyPlaceholder: 'API Key',
      },
      mailChimp: {
        apiKey: 'Mailchimp API Key',
        apiKeyPlaceholder: 'API Key',
      },
      rdStation: {
        apiKey: 'Seu Token',
        apiKeyPlaceholder: 'Token',
        help: 'Para finalizar a integração com o RD Station, clique no botão Salvar abaixo.',
      },
    },
    types: {
      getResponse: 'GetResponse',
      activeCampaign: 'Active Campaign',
      aweber: 'Aweber',
      convertKit: 'ConvertKit',
      eGoi: 'E-Goi',
      mailChimp: 'MailChimp',
      rdStation: 'RD Station',
    },
    actions: {
      new: 'NOVA CONTA',
      edit: 'Editar',
      delete: 'Deletar',
    },
    notify: {
      success: {
        delete: 'Serviço de email deletado com sucesso.',
        create: 'Serviço de email salvo com sucesso.',
        update: 'Serviço de email atualizado com sucesso.',
      },
      error: {
        aweber: 'Houve um erro na conexão com o aweber',
        rdstation: 'Houve um erro na conexão com o RDStation',
      },
    },
  },
  modal: {
    delete: {
      title: 'EXCLUIR',
      message: 'Você tem certeza que deseja excluir esse serviço de email? Esta ação é irreversível!',
      confirm: 'SIM, Excluir',
      cancel: 'Cancelar',
    },
  },
  notifications: {
    noNotifications: 'Não há novas notificações.',
    unableLoad: 'Não foi possível carregar as notificações no momento.',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/ptBr.js